import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePlan } from '../contexts/PlanContext';
import {
  LayoutDashboard, Globe, Database, User, Shield, LogOut, X, Lock, CreditCard
} from 'lucide-react';

interface NavItem {
  label: string;
  href: string;
  icon: typeof LayoutDashboard;
  requiredFeature?: string;
}

const navItems: NavItem[] = [
  { label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { label: 'Mijn sites', href: '/dashboard/sites', icon: Globe },
  { label: 'Backups', href: '/dashboard/backups', icon: Database, requiredFeature: 'manual_backup' },
  { label: 'Abonnement & Facturatie', href: '/dashboard/billing', icon: CreditCard },
  { label: 'Account', href: '/dashboard/account', icon: User },
  { label: 'Beveiliging', href: '/dashboard/security', icon: Shield },
];

export default function TenantSidebar({ onClose }: { onClose?: () => void }) {
  const { user, logout } = useAuth();
  const { isFeatureEnabled } = usePlan();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full bg-gray-900 text-white w-64">
      <div className="flex items-center justify-between h-16 px-6 border-b border-gray-700">
        <span className="text-lg font-bold">Occiput</span>
        {onClose && (
          <button onClick={onClose} className="lg:hidden text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        <ul className="space-y-1">
          {navItems.map(item => {
            const locked = item.requiredFeature && !isFeatureEnabled(item.requiredFeature as any);
            return (
              <li key={item.href}>
                <NavLink to={item.href} end={item.href === '/dashboard'} onClick={onClose}
                  className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-brand-600 text-white' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}`}>
                  <item.icon className="w-4 h-4" />
                  {item.label}
                  {locked && <Lock className="w-3 h-3 ml-auto text-gray-500" />}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="border-t border-gray-700 p-4">
        <p className="text-sm font-medium truncate">{user?.full_name}</p>
        <p className="text-xs text-gray-400 truncate mb-3">{user?.email}</p>
        <button
          onClick={() => { logout(); navigate('/login'); }}
          className="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Uitloggen
        </button>
      </div>
    </div>
  );
}
